<template>
    <div class="flow-step">
        <p class="flow-step__headline">{{step.Headline}}</p>
        <div class="flow-step__location-search">
        <LocationSearch @locationSearchApiSubmit="handleLocationSearchApiSubmitEvent" :dictionary="dictionary" :useAPI="true" :showLocationButton="true" />
        </div>
        <div v-if="departments.length > 0" class="flow__departments">
            <DepartmentCard v-for="department in departments" :key="department.Id" :department="department" :selected="selectedDepartment !== null && department.Id === selectedDepartment.Id" :dictionary="dictionary" @departmentSelect="handleDepartmentSelect" />

        </div>
        <nav class="flow-step__navigation">
            <button class="flow__button" type="button" v-on:click="handleStepChangeBackward">{{dictionary.FlowStepPreviousButtonText}}</button>
            <button class="flow__button" type="button" v-on:click="handleStepChangeForward" v-if="departmentSelected">{{dictionary.FlowStepNextButtonText}}</button>
        </nav>

    </div>
</template>

<script>
    import FlowStepItem from "./flowStepItem.vue";
    import DepartmentCard from "./departmentCard.vue";
    import LocationSearch from "./../locationSearch.vue";
    const serviceUrl = "/umbraco/api/departmentsapi/";

    export default {
        name: "flowLocationStep",
        components: {
            FlowStepItem,
            DepartmentCard,
            LocationSearch
        },
        data() {
            return {
                departmentSelected: false,
                departments: [],
                location: null
            }
        },
        mounted() {
            if (this.selectedDepartment != null) {
                this.departmentSelected = true;
                this.$emit('setNextStepId', this.nextStepId);
            }
        },
        props: ["step", "dictionary", "nextStepId", "zipsAndCitiesWithDepartments", "selectedDepartment"],
        methods: {
            handleStepChangeForward() {
                this.$emit('stepChangeForward', this.selectedDepartment.QueryAlias);
            },
            handleStepChangeBackward() {
                this.$emit('stepChangeBackward');
            },
            handleDepartmentSelect(departmentId) {
                this.departmentSelected = true;
                this.$emit('setNextStepId', this.nextStepId);
                this.$emit('departmentSelected', this.departments.filter(x => x.Id === departmentId)[0]);
            },
            handleLocationSearchApiSubmitEvent(location) {
                this.location = location;
                this.getDepartments();
            },
            getDepartments() {
                const vm = this;
                vm.$emit('toggleSpinner', true);

                $.get(serviceUrl + 'getDepartments',
                    {
                        lat: vm.location.latitude,
                        lng: vm.location.longitude,
                        city: vm.location.city,
                        take: 5,
                        skip:0
                    },
                    function (response) {
                        console.log(response);
                        if (response.Departments != null) {
                            vm.departments = response.Departments;
                        }
                        vm.$emit('toggleSpinner', false);

                    }).fail(function (error) {
                        vm.departments = null;
                        vm.$emit('toggleSpinner', false);


                    }).always(function () {
                    });
            }
        }
    };
</script>
